import { render } from "./SuspenserApp.vue?vue&type=template&id=a3e2cc18"
import script from "./SuspenserApp.vue?vue&type=script&lang=js"
export * from "./SuspenserApp.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__